import { get, post, remove } from "../common/http.services";

export function getCurrency(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/currency?page=${pageNumber}&size=${pageSize}&sort=currency,asc`, appContext, success, error);
}

export function saveCurrency(currencyModel: any, appContext: any, success: any, error: any) {
    return post(`/currency`, currencyModel, appContext, success, error);
}

export function deleteCurrency(currency: any, appContext: any, success: any, error: any) {
    return remove(`/currency?currency=${currency}`, appContext, success, error);
}

export function getCurrencyByName(currency: any, appContext: any, success: any, error: any) {
    return get(`/currency/findbycurrency?currency=${currency}`, appContext, success, error);
}

export function getHistory(pageNumber: any, pageSize: any, currency: any, appContext: any, success: any, error: any) {
    return get(`/currency/history?currency=${currency}&page=${pageNumber}&size=${pageSize}&sort=date,desc`, appContext, success, error);
}

export function getCurrencyRate(appContext: any, success: any, error: any) {
    return get(`/currency/rates`, appContext, success, error);
}
